/**
 * Dependencies.
 */
import { authService } from '@prz-dp/services';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import UserMenu from '@/ui/components/user-menu/user-menu.component.vue';
import { IUser } from '@/ui/components/user-menu/user-menu.types';

/**
 * Component.
 */
@Component({
  components: { UserMenu },
  name: 'app-document-scene'
})
export default class extends Vue {
  /**
   * Getter `user`.
   */
  get user(): IUser {
    const { keycloakProfile } = this.$kit?.auth || {};
    const { attributes, email = '', firstName = '', lastName = '' } =
      keycloakProfile || {};
    const { profilePhoto, userId } = attributes || {};
    const [firstProfilePhoto = ''] = profilePhoto || [];
    const [firstUserId = ''] = userId || [];
    const name = [firstName, lastName].filter(Boolean).join(' ');
    const photo =
      firstProfilePhoto && firstUserId
        ? `https://static.sscontent.com/realm/intranet/${firstUserId}/${firstProfilePhoto}`
        : null;

    return {
      email,
      initials: `${firstName.charAt(0)}${lastName.charAt(0)}`,
      name,
      photo
    };
  }

  /**
   * Handle logout.
   */
  async handleLogout() {
    const redirectUri = window.location.href
      .split('/')
      .slice(0, 3)
      .join('/');

    authService.logout({ redirectUri: `${redirectUri}/document` });
  }
}
